import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaDiscord, 
  FaTwitter, 
  FaYoutube, 
  FaInstagram, 
  FaCopy, 
  FaCheck,
  FaGamepad,
  FaStore,
  FaQuestionCircle,
  FaEnvelope
} from 'react-icons/fa';
import styles from './Footer.module.scss';
import { useTranslation } from '../../i18n';

const Footer: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [email, setEmail] = useState('');
  const { t } = useTranslation();
  const handleCopyIP = () => {
    navigator.clipboard.writeText('play.silverclaw.eu');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Subscribe:', email);
    setEmail('');
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles['footer-container']}>
        <div className={styles['footer-grid']}>
          <div className={styles['footer-brand']}>
            <div className={styles.logo}>
              <img
                src="https://cdn.silverclaw.eu/logo.png"
                alt="SilverClaw"
              />
              <span>SilverClaw</span>
            </div>
            <p className={styles.description}>
              {t('footer.desc')}
            </p>
            <div className={styles['server-ip']}>
              <span className={styles.label}>{t('footer.serverIp')}</span>
              <span className={styles.ip}>play.silverclaw.eu</span>
              <button 
                className={styles['copy-btn']} 
                onClick={handleCopyIP}
                aria-label="Copy server IP"
              >
                {copied ? <FaCheck /> : <FaCopy />}
              </button>
            </div>
          </div>

          <div className={styles['footer-section']}>
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li>
                <Link to="/">
                  <FaGamepad /> {t('footer.gameModes')}
                </Link>
              </li>
              <li>
                <Link to="/store">
                  <FaStore /> {t('nav.store')}
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  <FaQuestionCircle /> {t('nav.faq')}
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <FaEnvelope /> {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div className={styles['footer-section']}>
            <h4>{t('footer.community')}</h4>
            <ul>
              <li>
                <Link to="/about">{t('footer.aboutUs')}</Link>
              </li>
              <li>
                <Link to="/blog">{t('footer.newsUpdates')}</Link>
              </li>
              <li>
                <a href="https://discord.gg/silverclaw" target="_blank" rel="noopener noreferrer">
                  {t('footer.discord')}
                </a>
              </li>
              <li>
                <Link to="/team">{t('footer.ourTeam')}</Link>
              </li>
            </ul>
          </div>

          <div className={styles['footer-newsletter']}>
            <h4>{t('footer.stayUpdated')}</h4>
            <p>{t('footer.newsletter')}</p>
            <form className={styles['newsletter-form']} onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder={t('footer.emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">{t('footer.subscribe')}</button>
            </form>
            <div className={styles['payment-methods']}>
              <span className={styles.label}>{t('footer.payments')}</span>
              <div className={styles.methods}>
                <img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" />
                <img src="https://img.icons8.com/color/48/000000/mastercard.png" alt="Mastercard" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles['footer-bottom']}>
          <p className={styles.copyright}>
            {t('footer.copyright', { year: String(currentYear) })}
          </p>
          
          <div className={styles['social-links']}>
            <a href="https://discord.gg/silverclaw" target="_blank" rel="noopener noreferrer" aria-label="Discord">
              <FaDiscord />
            </a>
            <a href="https://twitter.com/silverclaw" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://youtube.com/silverclaw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://instagram.com/silverclaw" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>

          <div className={styles['legal-links']}>
            <Link to="/terms">{t('footer.tos')}</Link>
            <Link to="/privacy">{t('footer.privacy')}</Link>
            <Link to="/refund">{t('footer.refund')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
